var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 19H29.72L24 1l-5.72 18H0l14.75 10.19L9 47l15-11 15 11-5.75-17.81ZM35 41.49l-11-8-11 8 4.09-13.11L6.41 21h13.32L24 7.28 28.27 21h13.32l-10.67 7.37Z"
  })));
};
export default SvgStar;